
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/startups/pricing",
      function () {
        return require("private-next-pages/startups/pricing.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/startups/pricing"])
      });
    }
  